var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Naozaj chcete čerpať túto banku?")])]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.sadzba_schvalena,
      expression: "formData.sadzba_schvalena"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "urok",
      "id": "urok"
    },
    domProps: {
      "value": _vm.formData.sadzba_schvalena
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "sadzba_schvalena", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.fix,
      expression: "formData.fix"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "fixacia",
      "id": "fixacia"
    },
    domProps: {
      "value": _vm.formData.fix
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "fix", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.suma_nadobudnutie,
      expression: "formData.suma_nadobudnutie",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "vyskauveru",
      "id": "vyskauveru"
    },
    domProps: {
      "value": _vm.formData.suma_nadobudnutie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "suma_nadobudnutie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.suma_refinancovanie,
      expression: "formData.suma_refinancovanie",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "vyskauveru",
      "id": "vyskauveru"
    },
    domProps: {
      "value": _vm.formData.suma_refinancovanie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "suma_refinancovanie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.formData.suma_bezucel,
      expression: "formData.suma_bezucel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "vyskauveru",
      "id": "vyskauveru"
    },
    domProps: {
      "value": _vm.formData.suma_bezucel
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "suma_bezucel", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.splatnost,
      expression: "formData.splatnost"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "splatnost",
      "id": "splatnost"
    },
    domProps: {
      "value": _vm.formData.splatnost
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "splatnost", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.splatka,
      expression: "formData.splatka"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "splatka",
      "id": "splatka"
    },
    domProps: {
      "value": _vm.formData.splatka
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "splatka", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.poplatok_za_poskytnutie,
      expression: "formData.poplatok_za_poskytnutie"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "poplatok_za_poskytnutie",
      "id": "poplatok_za_poskytnutie"
    },
    domProps: {
      "value": _vm.formData.poplatok_za_poskytnutie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "poplatok_za_poskytnutie", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    staticClass: "image-bcg",
    attrs: {
      "src": _vm.payload.bank.logo_square,
      "width": "100",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "blc-color MGtop20px center"
  }, [_vm._v(" Kliknutím na čerpať sa sprístupní krok 4 - čerpanie, pričom klient dostane emailovú notifikáciu, že sa pracuje na príprave úverovej dokumentácie. ")]), _c('button', {
    staticClass: "w-button",
    on: {
      "click": _vm.saveStatus
    }
  }, [_vm._v(" Áno, čerpať ")])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "urok"
    }
  }, [_vm._v("Úroková sadzba"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "fixacia"
    }
  }, [_vm._v("Fixácia"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyskauveru"
    }
  }, [_vm._v("Výška úveru nadobudnutie"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyskauveru"
    }
  }, [_vm._v("Výška úveru refinancovanie"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyskauveru"
    }
  }, [_vm._v("Výška úveru bezúčel"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "splatnost"
    }
  }, [_vm._v("Splatnosť"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "splatnost"
    }
  }, [_vm._v("Splátka"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "splatnost"
    }
  }, [_vm._v("Poplatok"), _c('strong')]);

}]

export { render, staticRenderFns }